import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RealEstateDocumentFetchModal } from "@/features/map/components/RealEstateDocumentFetchModal";

export const RealEstateDocumentFetchPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = (): void => {
    navigate("/mypage");
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        minHeight: "100%",
      }}
    >
      <RealEstateDocumentFetchModal
        open={true}
        address=""
        chibanList={[{ prefName: "", location: "", chibanAndKaokuNumber: "" }]}
        kaokuNumberList={[]}
        onCancel={handleClose}
        onClose={handleClose}
      />
    </Box>
  );
};
